import { DEEP_PIECES } from './deepArtifacts';
import { DESCENT_PIECES } from './descentArtifacts';

const METALS = [
  { id: 'silver', name: 'Silver', label: 'Sterling Silver' },
  { id: 'white-gold', name: '14k White Gold', label: '14k White Gold' },
];

const byId = (list, id) => list.find((x) => x.id === id) || list[0];

export const ARTIFACT_REALMS = {
  deep: {
    key: 'deep',
    name: 'The Deep',
    path: '/realm/the-deep',
    className: 'realm--deep',
    pieces: DEEP_PIECES,
    metals: METALS,
    metalsInOriginal: true,
    stones: [
      { id: 'sky-blue', name: 'Sky Blue', label: 'Sky Blue Moissanite' },
      { id: 'colorless', name: 'Colorless', label: 'Colorless Moissanite', ex: true },
    ],
    defaults: { metal: 'silver', stone: 'sky-blue' },
    storageKey: 'ikarus-deep-config',
    metalDetail: { original: 'Sterling Silver / 14k White Gold', ex: 'Sterling Silver / 14k White Gold' },
    stoneDetail: { original: 'Sky Blue Moissanite', ex: 'Colorless Moissanite (EX)' },
    backdrop: { wide: '/realms/deep-altar.webp', mobile: '/realms/deep-altar-m.webp', altx: 0.525, altxMobile: 0.552, alty: 0.76 },
    rail: { before: { to: '/#world', name: 'The World' }, after: { to: '/realm/the-deep', name: 'The Deep' } },
    interest(piece, metalId, stoneId) {
      return `${piece.name} — ${byId(METALS, metalId).label}, ${byId(this.stones, stoneId).label}`;
    },
  },
  descent: {
    key: 'descent',
    name: 'The Descent',
    path: '/realm/the-descent',
    className: 'realm--descent',
    pieces: DESCENT_PIECES,
    metals: METALS,
    metalsInOriginal: false,
    stones: [
      { id: 'black', name: 'Black', label: 'Black Moissanite' },
      { id: 'colorless', name: 'Colorless', label: 'Colorless Moissanite', ex: true },
    ],
    defaults: { metal: 'silver', stone: 'black' },
    storageKey: 'ikarus-descent-config',
    metalDetail: { original: 'To be announced', ex: 'Sterling Silver / 14k White Gold' },
    stoneDetail: { original: 'Black Moissanite', ex: 'Colorless Moissanite (EX)' },
    backdrop: { wide: '/realms/descent-altar.webp', mobile: '/realms/descent-altar-m.webp', altx: 0.505, altxMobile: 0.51, alty: 0.66 },
    rail: { before: { to: '/realm/the-deep', name: 'The Deep' }, after: { to: '/realm/the-descent', name: 'The Descent' } },
    interest(piece, metalId, stoneId) {
      const stone = byId(this.stones, stoneId);
      if (!stone.ex) return `${piece.name} — ${stone.label} (metal to be confirmed)`;
      return `${piece.name} — ${byId(METALS, metalId).label}, ${stone.label} (EX)`;
    },
  },
};

export const findArtifact = (slug) => {
  for (const realm of Object.values(ARTIFACT_REALMS)) {
    const index = realm.pieces.findIndex((p) => p.slug === slug);
    if (index >= 0) return { realm, piece: realm.pieces[index], index };
  }
  return null;
};

export const neighbours = (realm, slug) => {
  const i = realm.pieces.findIndex((p) => p.slug === slug);
  const n = realm.pieces.length;
  return { prev: realm.pieces[(i - 1 + n) % n], next: realm.pieces[(i + 1) % n] };
};
